import Backbone from 'backbone'
import _ from 'lodash'
import FormView from 'scoreboard/components/form-view'
import template from './group-similar-time-ranges-view.hbs'
import GroupedPeriodRangeSelector from 'scoreboard/components/designer/grouped-period-range-selector'
import unwrapModel from 'scoreboard/components/unwrap-model'

/**
 * #36028 Displays when selecting "Group Similar Time Ranges" in the dataset table
 * "Choose Rows" menu. This allows a user to set the grouping calendar and the
 * breakdown calendar
 */
const GroupSimilarTimeRangesView = Backbone.View.extend({
	tagName: 'form',

	events: {
		'click .cancel': 'cancel'
	},

	initialize: function(options = {}) {
		// We want to work with a copy of the model so the change events from
		// {@link GroupedPeriodRangeSelector} don't cause updates until the user
		// clicks save
		let table = unwrapModel(options.model).table
		this.model = GroupedPeriodRangeSelector.createModel(table)

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false,
			// Both calendar fields are populated by default, so the user doesn't
			// have to make any changes before submitting
			allowCleanSubmission: true
		})
	},

	render: function() {
		this.$el.html(template())
		this.groupedPeriodRangeSelector = new GroupedPeriodRangeSelector({
			model: this.model,
			usePeriodRanges: false
		})

		this.$('.group-similar-time-ranges-container')
			.prepend(this.groupedPeriodRangeSelector.el)
		this.groupedPeriodRangeSelector.render()

		this.listenTo(this.groupedPeriodRangeSelector, 'change', () => {
			this.formView.once('change', () => this.trigger('change'))
			this.formView.change()
		})

		this.formView.start()
		return this
	},

	submit: function() {
		this.trigger('done', this.groupedPeriodRangeSelector.idsAndSummaryType())
	},

	cancel: function() {
		this.trigger('cancel')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.groupedPeriodRangeSelector], 'remove')
	}
})

export default GroupSimilarTimeRangesView
GroupSimilarTimeRangesView.__filename__ = 'datasets/overview/group-similar-time-ranges-view.js'
